export default "__VITE_ASSET__BdPdoHo0__"